var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recomended_slider"},[_c('CardSlider',{attrs:{"items":_vm.items,"collectionIds":_vm.collectionIds,"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }